// Generic, keyed version of applications-list-view.js for the admission contract
// list pages (Kontrakt 2024/2025/2026, Ketganlar, Faolsizlar). Persists a list
// "view" (active tab, filter selections, pagination page) for the current browser
// session, so returning via the "Orqaga" button restores the exact view instead
// of resetting to tab 0 / page 1.
//
// Session-scoped on purpose: a browsing position should not survive a tab close.
// The app's <router-view :key="$route.fullPath"> fully re-mounts the list on every
// navigation, so the state cannot live in component memory and must NOT live in the
// URL query (that would re-mount the list on every page change). sessionStorage is
// the right home. Each page passes its own key (e.g. "contracts2026.view").

export function saveListView(key, view) {
  try {
    sessionStorage.setItem(key, JSON.stringify(view));
  } catch (_) { /* quota / private mode — silent */ }
}

export function loadListView(key) {
  let raw;
  try { raw = sessionStorage.getItem(key); } catch (_) { return null; }
  if (!raw) return null;
  try { return JSON.parse(raw); } catch (_) { return null; }
}
